import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import isEmpty from 'lodash/isEmpty';
import PlusIcon from 'assets/svgs/plusIcon.svg';
import PencilIcon from 'assets/svgs/pencilIcon.svg';
import TrashIcon from 'assets/svgs/trashIcon.svg';
import {
  TooltipItem,
} from 'shared/components';

import './StaffCard.scss';

const StaffCard = ({
  className, title, staff, room, roleId, onRemoveStaffRole, showDelete, showEdit, onOpenModal, showContactInfo,
}) => {
  const { t } = useTranslation();
  const addContactInfo = showContactInfo ? `\n${staff.emailAddress}\n${staff.phone}` : '';
  const customClass = showContactInfo ? 'name non-personnel' : 'name';
  return (
    <div className={`staff-card-section ${className}`}>
      <div className="left-content">
        <div className="text-bold">{title}</div>
        <TooltipItem
          item={!isEmpty(staff)
            ? staff.lastName.concat(', ', staff.firstName) + addContactInfo : t('staffManagement.unassignedLabel')}
          customClass={customClass}
        />
      </div>

      <div className="button-container">
        {showDelete
          && (
            <button
              className="btn-link-remove"
              onClick={() => onRemoveStaffRole(staff)}
            >
              <TrashIcon />
              <span className="hide-mobile">{t('staffManagement.removeRoleLabel')}</span>
            </button>
          )}

        {showEdit && (
          <button
            className="btn btn-small btn-outline"
            onClick={() => onOpenModal(staff, roleId, room)}
          >
            {!isEmpty(staff)
              ? <><PencilIcon /> {t('common.labels.edit')} </>
              : (
                <><PlusIcon />
                  {' '}
                  {t('common.labels.assign')}
                </>
              )
            }
          </button>
        )}
      </div>
    </div>
  );
};

StaffCard.propTypes = {
  roleId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  room: PropTypes.shape({}),
  className: PropTypes.string,
  title: PropTypes.string.isRequired,
  staff: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    emailAddress: PropTypes.string,
    phone: PropTypes.string,
    roleName: PropTypes.string,
  }),
  showEdit: PropTypes.bool,
  showDelete: PropTypes.bool,
  onOpenModal: PropTypes.func.isRequired,
  onRemoveStaffRole: PropTypes.func,
  showContactInfo: PropTypes.bool,
};

StaffCard.defaultProps = {
  className: '',
  staff: {},
  showEdit: true,
  showDelete: false,
  onRemoveStaffRole: () => { },
  room: {},
  showContactInfo: false,
};

export default StaffCard;
